import { Tab, Tabs } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React from 'react'
import { useLocation } from 'react-router-dom'

import ClassBatchPage from '../Batch'
import ClassSummerCampBatchPage from '../SummerCampBatch'

// One Batches page with a top tab strip, replacing the two separate sidebar
// entries. `/classes/summer-camp` still resolves here and opens on that tab, so
// old links keep working.
const TABS = [
  { id: 'common', label: 'Common', Comp: ClassBatchPage },
  { id: 'summer-camp', label: 'Summer Camp', Comp: ClassSummerCampBatchPage }
]

const useStyles = makeStyles((theme) => ({
  root: { minWidth: 0, overflowX: 'hidden' },
  tabs: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingLeft: theme.spacing(1)
  },
  tab: {
    minWidth: 'auto',
    minHeight: 44,
    '&.Mui-selected': { fontWeight: 600 }
  }
}))

const ClassBatches = () => {
  const classes = useStyles()
  const { pathname } = useLocation()
  const [tab, setTab] = React.useState(() =>
    pathname.includes('summer-camp') ? 'summer-camp' : 'common'
  )

  const Active = (TABS.find((t) => t.id === tab) || TABS[0]).Comp

  return (
    <div className={classes.root}>
      <Tabs
        className={classes.tabs}
        value={tab}
        onChange={(e, v) => setTab(v)}
        textColor="primary"
        TabIndicatorProps={{ style: { display: 'none' } }}
      >
        {TABS.map((t) => (
          <Tab
            key={t.id}
            value={t.id}
            label={t.label}
            className={classes.tab}
          />
        ))}
      </Tabs>
      <Active />
    </div>
  )
}

export default ClassBatches
